import { Query } from '@apollo/client/react/components'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { useParams, useLocation, useNavigate } from 'react-router-dom'

import { Container, ErrorComponent, LoadingComponent } from 'components'
import Header from './Header'
import SidebarNav from './SidebarNav'
import MainContent from './MainContent'

import query from './TrailDetails.query.js'

import styles from './TrailDetails.module.css'

class TrailDetailsInner extends Component {
  static propTypes = {
    navigate: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    matchUrl: PropTypes.string.isRequired,
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }

  getItems = entity => {
    let currentItem
    let currentItemObj = {}
    let prevItem
    let nextItem = null
    const presentation = entity.presentationEnabled ? entity.presentation : null

    const nodes = this.entityTrailNodes(entity)

    if (nodes.length > 0) {
      const firstNodeId = nodes[0].nid

      if (!this.props.location.hash) {
        if (!presentation) {
          currentItemObj = this.activateNode(firstNodeId)
        }
      } else {
        currentItemObj = nodes
          .map((item, index) => ({
            nid: item.nid,
            pos: index,
          }))
          .find(item => item.nid === parseInt(this.props.location.hash.substr(1), 10))

        if (!currentItemObj) {
          currentItemObj = this.activateNode(firstNodeId, true)
        }
      }

      if (Object.keys(currentItemObj).length > 0) {
        currentItem = currentItemObj.nid

        if (nodes.length > 1) {
          const nextNode = nodes[currentItemObj.pos + 1]
          const prevNode = nodes[currentItemObj.pos - 1]

          nextItem = {
            nid: nextNode ? nextNode.nid : null,
            title: nextNode ? nextNode.title : null,
            pos: currentItemObj.pos + 2,
          }
          prevItem = {
            nid: prevNode ? prevNode.nid : null,
            title: prevNode ? prevNode.title : null,
            pos: currentItemObj.pos,
          }

          if (currentItemObj.pos === 0) {
            prevItem = {}
          } else if (currentItemObj.pos === nodes.length - 1) {
            nextItem = {}
          }
        }
      }
    }

    return { currentItem, prevItem, nextItem, presentation, nodes }
  }

  activateNode = (nid, redirect) => {
    if (redirect) {
      this.props.navigate(`#${nid}`, { replace: true })
    }

    return { nid, pos: 0 }
  }

  entityTrailNodes = entity => {
    if (entity && entity.trailArticles && entity.trailArticles.nodes) {
      const nodes = entity.trailArticles.nodes.filter(Boolean)

      return nodes.length > 1 ? this.sortNodes(nodes) : nodes
    }
    return []
  }

  sortNodes = nodes => nodes.sort((a, b) => a.weight - b.weight)

  render() {
    const { matchUrl } = this.props

    return (
      <>
        <Query query={query} variables={{ path: matchUrl }}>
          {({ loading, error, data }) => {
            if (loading) {
              return <LoadingComponent />
            }

            if (error) {
              return <ErrorComponent message={`Error! ${error.message}`} />
            }

            if (!data.route || !data.route.entity) {
              return <ErrorComponent message='Página não encontrada' />
            }

            const { entity } = data.route
            const { currentItem, nextItem, prevItem, presentation, nodes } = this.getItems(entity)

            if (nodes.length === 0) {
              return <ErrorComponent message='Não há conteúdo disponível para essa trilha.' />
            }

            return (
              <>
                <Header title={entity.name} />
                <Container flex>
                  <div className={styles.wrapper}>
                    <SidebarNav currentItem={currentItem} items={nodes} title={entity.name} />
                    <MainContent
                      currentItem={currentItem}
                      nextItem={nextItem}
                      prevItem={prevItem}
                      items={nodes}
                      presentation={presentation}
                    />
                  </div>
                </Container>
              </>
            )
          }}
        </Query>
      </>
    )
  }
}

const TrailDetails = () => {
  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const matchUrl = `/trails/${params.slug}`

  return (
    <TrailDetailsInner
      location={location}
      navigate={navigate}
      params={params}
      matchUrl={matchUrl}
    />
  )
}

export default TrailDetails
